import React, { useEffect, useRef } from "react";

import { useHttp } from "../hooks/useHttp";
import { useQuery } from "@tanstack/react-query";
import { CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow } from "@coreui/react";
import ProspectPagination from "./Prospect/ProspectPagination";
import LoadingCenter from "./LoadingCenter";

const FavLotesTable = props => {
  const { searchData } = props;
  const request = useHttp();
  const page = useRef(1);
  const { data: favLots, refetch, isLoading, isFetching, isSuccess } = useQuery(["fav-lots-table"], () => request({ url: `/users/favoritos?page=${page.current}&titulo=${searchData.title || ""}&user=${searchData.name || ""}`, method: "GET" }), { refetchOnWindowFocus: false });
  console.log(favLots);

  useEffect(() => {
    refetch();
  }, [searchData]);

  if (isLoading || isFetching) return <LoadingCenter />;

  return (
    <div className="y-p-20 x-p-20">
      <CTable hover>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col">
              <span className="text-color">Nome cliente</span>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col">
              <span className="text-color">Título lote</span>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col">
              <span className="text-color">Ativo</span>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col">
              <span className="text-color">Favoritado em</span>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col">
              <span className="text-color">Código lote</span>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col">
              <span className="text-color">Link</span>
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {favLots?.data?.fav_lots.map(item => {
            return (
              <CTableRow>
                <CTableDataCell align="top">
                  <span className="text-color">
                    {item.nome_cliente}
                  </span>
                </CTableDataCell>
                <CTableDataCell align="top">
                  <span className="text-color">
                    {item.nome_lote}
                  </span>
                </CTableDataCell>
                <CTableDataCell align="top">
                  <span className="text-color">
                    {item.status_lote ? "Ativo" : "Inativo"}
                  </span>
                </CTableDataCell>
                <CTableDataCell align="top">
                  <span className="text-color">
                    {item.data_favoritado_cliente}
                  </span>
                </CTableDataCell>
                <CTableDataCell align="top">
                  <span className="text-color">
                    {item.codigo_lote}
                  </span>
                </CTableDataCell>
                <CTableDataCell align="top">
                  <a href={`https://www.usadaomaquinas.com.br/Gerencial_web32yw/PG_Produtos/Visualizar.php?Codigo=${item.codigo_lote}`} target="_blank">
                    Link
                  </a>
                </CTableDataCell>
              </CTableRow>
            );
          })}
        </CTableBody>
      </CTable>
      <ProspectPagination customer={favLots} page={page} refetch={refetch} />
    </div>
  );
}

export default FavLotesTable;